import { ConfigType } from '../utils/requestAPI';

export type PricingType = {
  priceDenom: string;
  recurringPeriod?: string;
  planDescription: { title: string; description: string }[];
  title: string;
  price: number;
  isRecurring: boolean;
  isActive: boolean;
  planType: string;
  notes: string;
};

type ParamsType = {
  page: number;
  limit: number;
};

const pricingApi = {
  createPricing: (data: PricingType): ConfigType => {
    return {
      url: '/pricing-plan',
      method: 'post',
      data,
    };
  },
  getAllPricing: (params: ParamsType): ConfigType => {
    return {
      url: '/pricing-plan',
      method: 'get',
      params,
      config: { store: { action: 'set', key: 'pricing.data' } },
    };
  },
  getPricingPlanType: (planType: string): ConfigType => {
    return {
      url: `/pricing-plan/plan-type/${planType}`,
      method: 'get',
      config: { store: { action: 'set', key: 'pricingPlanTypeData.data' } },
    };
  },
  getPricingDetail: (id: string): ConfigType => {
    return {
      url: `/pricing-plan/${id}`,
      method: 'get',
      config: { store: { action: 'set', key: 'pricingDetails' } },
    };
  },
  deletePricing: (id: string): ConfigType => {
    return {
      url: `/pricing-plan/${id}`,
      method: 'delete',
    };
  },
  statusUpdatePricingPlan: (id: string, isActive: boolean): ConfigType => {
    return {
      url: `/pricing-plan/${id}/activation`,
      method: 'patch',
      data: { isActive },
    };
  },
};

export default pricingApi;
